/* Тосты: очередь уведомлений в правом нижнем углу. */
import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

const ToastContext = createContext(null);

const ICONS = { ok: '✓', error: '!', info: '·' };

export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);
  const nextId = useRef(1);

  const remove = useCallback((id) => {
    setItems((list) => list.map((t) => (t.id === id ? { ...t, leaving: true } : t)));
    setTimeout(() => setItems((list) => list.filter((t) => t.id !== id)), 320);
  }, []);

  const push = useCallback(
    (title, note = '', kind = 'ok', life = 3600) => {
      const id = nextId.current++;
      setItems((list) => [...list.slice(-4), { id, title, note, kind, life }]);
      setTimeout(() => remove(id), life);
      return id;
    },
    [remove],
  );

  const value = useMemo(
    () => ({
      push,
      remove,
      success: (title, note) => push(title, note, 'ok'),
      error: (title, note) => push(title, note, 'error', 5200),
      info: (title, note) => push(title, note, 'info'),
    }),
    [push, remove],
  );

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toasts" role="status" aria-live="polite">
        {items.map((t) => (
          <div
            key={t.id}
            className={`toast toast--${t.kind}${t.leaving ? ' is-out' : ''}`}
            style={{ '--toast-life': `${t.life}ms` }}
            onClick={() => remove(t.id)}
          >
            <span className="toast__icon">{ICONS[t.kind] || ICONS.info}</span>
            <div className="toast__body">
              <div className="toast__title">{t.title}</div>
              {t.note ? <div className="toast__note">{t.note}</div> : null}
            </div>
            <span className="toast__bar" />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast должен вызываться внутри ToastProvider');
  return ctx;
}
